export var BargainType;
(function (BargainType) {
    BargainType["OPEN"] = "Open";
    BargainType["NEGO"] = "Nego";
    BargainType["CANCEL"] = "Cancel";
    BargainType["NEGOSPV"] = "NegoSpv";
    BargainType["APPROVED"] = "Approved";
})(BargainType || (BargainType = {}));
